import React, {useState} from 'react';
import * as yup from 'yup';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useFormik } from 'formik';
import {useForgotPasswordMutation} from 'apis/authenticationApi';
import {useNavigate} from "react-router-dom";

const ForgotPasswordForm = () => {
    const schema = yup.object({
        email: yup.string().required('Email is a required field')
    });
    const navigate = useNavigate();
    const [forgotPassword] = useForgotPasswordMutation();
    const [messages, setMessages] = useState("");

    const formik = useFormik({
        initialValues: {email: ''},
        validationSchema: schema,
        onSubmit: async (data) => {
            setMessages("");

            const results = await forgotPassword(data);

            if(results?.data?.status === 'ok') {
                navigate('/auth/forgot-password-thankyou');
            }
            else {
                setMessages("Email Not Found");
            }
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <form onSubmit={formik.handleSubmit} className="formgrid grid">
            <div className="col-12">
                <span className="error">{messages}</span>
            </div>
            <div className="field col-12">
                <span className="p-float-label">
                    <InputText id="email" name="email" className="inputfield w-full" value={formik.values?.email} onChange={formik.handleChange} />
                    <label htmlFor="email" className={classNames({ 'p-error': isFormFieldValid('email') })}>Email</label>
                </span>
                {getFormErrorMessage('email')}
            </div>
            <div className="field col-12">
                <Button type="submit" label="Forgot Password" />
            </div>
        </form>
    );
}

export default ForgotPasswordForm;